export default "__VITE_ASSET__BSk6Ky29__"